// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowLeftTwoRectangles } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-left-two-rectangles': IconArrowLeftTwoRectangles;
    }
}

/**
 * The icon component for the 'arrowLeftTwoRectangles' icon
 */
export class IconArrowLeftTwoRectangles extends IconSvg {
    public constructor() {
        super(arrowLeftTwoRectangles);
    }
}

registerIconSvg('icon-arrow-left-two-rectangles', IconArrowLeftTwoRectangles);
export const iconArrowLeftTwoRectanglesTag = 'nimble-icon-arrow-left-two-rectangles';
